import { activeColumnDef } from "@/controls/ag-grid/components/ActiveColumn";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import { Box, IconButton, Tooltip } from "@mui/material";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import ColorCircleRenderer from "../components/ColorPicker/ColorCircleRendered";
import { DelayCategory } from "../models/CatalogCategory";

type Props = {
	setSelectedRowData: (category: DelayCategory) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};

export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "DelayCategoryName",
			headerName: "Name",
			flex: 1,
			minWidth: 130,
		},
		{
			field: "Description",
			headerName: "Description",
			flex: 2,
			minWidth: 200,
		},
		{
			field: "DelayCategoryColor",
			headerName: "Color",
			sortable: false,
			flex: 1,
			cellRenderer: ColorCircleRenderer,
			minWidth: 130,
		},
		activeColumnDef<DelayCategory>({ field: "IsActive" }),
		{
			headerName: "",
			width: 110,
			minWidth: 110,
			maxWidth: 110,
			sortable: false,
			filter: false,
			resizable: false,
			suppressSizeToFit: true,
			cellRenderer: (params: ICellRendererParams<DelayCategory>) => {
				const category = params.data;
				if (!category) return null;
				const open = (modal: "update" | "delete") => {
					setSelectedRowData(category);
					setShowModal(modal);
				};
				return (
					<Box
						className="buttons"
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							gap: 1,
							height: "100%",
							opacity: 0,
							transition: "opacity 0.1s ease-in-out",
						}}
					>
						<Tooltip title="Edit">
							<IconButton
								size="small"
								color="primary"
								sx={{ p: 0.25 }}
								onClick={(e) => {
									e.stopPropagation();
									open("update");
								}}
							>
								<EditIcon fontSize="small" />
							</IconButton>
						</Tooltip>
						<Tooltip title="Delete">
							<IconButton
								size="small"
								color="error"
								sx={{ p: 0.25 }}
								onClick={(e) => {
									e.stopPropagation();
									open("delete");
								}}
							>
								<DeleteIcon fontSize="small" />
							</IconButton>
						</Tooltip>
						<Tooltip title="Options">
							<IconButton
								size="small"
								sx={{ p: 0.25 }}
								onClick={(e) => {
									e.stopPropagation();
									showContextMenu(e, category, "categoriesContext");
								}}
							>
								<FormatListBulletedSharpIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Box>
				);
			},
		},
	];

	return { columnDefs };
};
